import React from "react";

// components
import { BootstrapModal } from "../BootstrapModal/Modal";
import Button from "../Button/Button";

// react icons
import { CgClose } from "react-icons/cg";
import Typography from "../Typography/Typography";
import { useGetChangeBrandStauts } from "../../hooks/useContent";

const BrandChangeStatusModal = ({ handleClose, show, brandId }) => {
  const { mutateAsync: changeBrand } = useGetChangeBrandStauts();

  const changeBrandStatus = async (data) => {
    await changeBrand({ brand_id: data });
  };
  return (
    <BootstrapModal
      modaltitle={"تغییر وضعیت برند"}
      handleClose={handleClose}
      show={show}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <Typography>آیا از تغییر وضعیت این برند مطمئن هستید؟</Typography>
      <div className="row justify-content-end ms-1">
        <Button
          className="ms-3"
          bgColor="#009ef7"
          color="#fff"
          small="60px"
          onclick={() => {
            changeBrandStatus(brandId);
            handleClose();
          }}
        >
          بله
        </Button>
        <Button
          bgColor="#f1416c"
          color="#fff"
          small="60px"
          onclick={handleClose}
        >
          خیر
        </Button>
      </div>
    </BootstrapModal>
  );
};

export default BrandChangeStatusModal;
